import { api } from '@/lib/api';

export type LookupOption = { code: string; display_name: string };

export async function fetch_walker_specializations(): Promise<LookupOption[]> {
  const res = await api.get<LookupOption[]>('/lookups/walker-specializations');
  return res.data;
}

export async function fetch_vet_specializations(): Promise<LookupOption[]> {
  const res = await api.get<LookupOption[]>('/lookups/vet-specializations');
  return res.data;
}

export async function fetch_languages(): Promise<LookupOption[]> {
  const res = await api.get<LookupOption[]>('/lookups/languages');
  return res.data;
}
